import * as React from "react";
import { formatPercent } from "@eave/shared/utils/percent";
import { formatCurrency } from "@eave/shared/utils/currency";
import {
  findFieldValueForSection,
  getLatestCreatedDocOfType,
} from "web_modules/underwriter_dashboard/shared";

import HurdleView from "underwriter_dashboard/shared/HurdleView";
import { HurdleProps } from "underwriter_dashboard/HurdleEditor";
import { formatDate, verticalHeaderTRUSTable } from "./shared";
import LoanInfo from "./LoanInfo";
import PropertyInfo from "./PropertyInfo";
import BorrowerInfo from "./BorrowerInfo";
import LiabilitiesInfo from "./LiabilitiesInfo";

const styles = require("./styles.module.scss");

interface HurdleEditorProps extends HurdleProps {
  dispatch?: Function;
}

class MortgageInsuranceSummaryEditor extends React.Component<HurdleEditorProps, any> {
  render() {
    const { app, hurdle, onHide } = this.props;

    const mortgageInsuranceCertificate = getLatestCreatedDocOfType(
      app,
      "mortgage_insurance_certificate",
    );
    const commitmentNumber =
      mortgageInsuranceCertificate &&
      findFieldValueForSection(mortgageInsuranceCertificate, "commitment_number", "main");
    const commitmentEffectiveDate =
      mortgageInsuranceCertificate &&
      findFieldValueForSection(mortgageInsuranceCertificate, "commitment_effective_date", "main");
    const commitmentExpirationDate =
      mortgageInsuranceCertificate &&
      findFieldValueForSection(mortgageInsuranceCertificate, "commitment_expiration_date", "main");

    const mortgageInsuranceQuote = getLatestCreatedDocOfType(app, "mortgage_insurance_quote");
    const quoteID =
      mortgageInsuranceQuote &&
      findFieldValueForSection(mortgageInsuranceQuote, "quote_id", "main");
    const quoteDate =
      mortgageInsuranceQuote &&
      findFieldValueForSection(mortgageInsuranceQuote, "quote_date", "main");
    const quoteValidThroughDate =
      mortgageInsuranceQuote &&
      findFieldValueForSection(mortgageInsuranceQuote, "quote_valid_through_date", "main");

    const table1 = [
      { label: "Commitment/Certificate Number", value: commitmentNumber },
      { label: "Commitment Effective Date", value: formatDate(commitmentEffectiveDate) },
      { label: "Commitment Expiration Date", value: formatDate(commitmentExpirationDate) },
      { label: "MI Provider", value: "MGIC" },
      { label: "Automated Underwriting System (AUS)", value: "Desktop Originator" },
      { label: "DO Recommendation", value: app.computed_properties.du_recommendation },
    ];
    const table2 = [
      { label: "Quote ID", value: quoteID },
      { label: "Quote Date", value: formatDate(quoteDate) },
      { label: "Quote Valid Through Date", value: formatDate(quoteValidThroughDate) },
      { label: "MGIC ID Number", value: "04-645-6-8419" },
      { label: "DO Casefile ID", value: app.computed_properties.fnma_identifier },
    ];
    const table3 = [
      { label: "MI Premium Paid By", value: "BPMI" },
      {
        label: "MI Coverage",
        value: formatPercent(Number(app.decision.mortgage_insurance_coverage) * 100, 0),
      },
      {
        label: "Initial Monthly MI Premium",
        value: formatCurrency(app.decision.monthly_mortgage_insurance[0].amount, 2, 2),
      },
      {
        label: "MI Premium Due to Activate",
        value: formatCurrency(app.decision.mortgage_insurance_premium_due_to_activate, 2, 2),
      },
      {
        label: "Initial MI Rate",
        value: formatPercent(Number(app.decision.mortgage_insurance_rate1) * 100, 2),
      },
      {
        label: "Renewal MI Rate Years 2-10",
        value: formatPercent(Number(app.decision.mortgage_insurance_rate2_to10) * 100, 2),
      },
      {
        label: "Renewal MI Rate Years 11-Term",
        value: formatPercent(Number(app.decision.mortgage_insurance_rate11) * 100, 2),
      },
    ];
    const table4 = [
      { label: "MI Premium Type", value: "Monthly" },
      { label: "MI Program", value: "Standard" },
      { label: "MI Refund Option", value: "Non-Refundable" },
      { label: "MI Renewal Option", value: "Constant" },
      { label: "Employee Relocation", value: "No" },
      { label: "HFA 1st Mortgage Program", value: "Not applicable" },
      { label: "MGIC Program ID #1", value: "Not applicable" },
    ];

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide} className={styles.container}>
        <h2>Mortgage Insurance Summary</h2>
        <div className={styles.table}>
          {verticalHeaderTRUSTable(table1)}
          {verticalHeaderTRUSTable(table2)}
        </div>
        <h2>Mortgage Insurance Information</h2>
        <div className={styles.table}>
          {verticalHeaderTRUSTable(table3)}
          {verticalHeaderTRUSTable(table4)}
        </div>
        <LoanInfo app={app} />
        <PropertyInfo app={app} />
        <BorrowerInfo app={app} borrowerNum={1} />
        {app.has_borrower2 && <BorrowerInfo app={app} borrowerNum={2} />}
        <LiabilitiesInfo app={app} />
      </HurdleView>
    );
  }
}

export default MortgageInsuranceSummaryEditor;
